import { Button, CircularProgress, Grid, Icon, Paper, TextField, Tooltip } from "@material-ui/core";
import { useState, Fragment } from 'react';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Redirect } from "react-router";
import ArtApi from "../../api/ArtApi";

export const AddWaterEvent = () => {
    const [error, setError] = useState<string | null>(null);
    const [reviewers, setReviewers] = useState<string | null>(null);
    const [deviceId, setDeviceId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [regionOfInterestStartDate, setRegionOfInterestStartDate] = useState<Date | null>(new Date())
    const [endDate, setEndDate] = useState<Date | null>(new Date())
    const [trainingTime, setTrainingTime] = useState<string | null>(null);
    const [tags, setTags] = useState<string>("");

    const handleComplete = () => {
        setIsLoading(true);
        if (regionOfInterestStartDate === null) {
            setIsLoading(false);
            setIsSuccess(false);
            setError("Start Date is Null");
            return
        }

        if (endDate === null) {
            setIsLoading(false);
            setIsSuccess(false);
            setError("End Date is Null");
            return;
        }

        if (deviceId.length !== 24) {
            setIsLoading(false);
            setIsSuccess(false);
            setError("The length of the Deivce ID is incorrect");
            return;
        }

        let reviewerList = reviewers?.replaceAll(' ', '').split(',');

        ArtApi.createWaterEvent(deviceId, regionOfInterestStartDate, endDate, reviewerList, trainingTime, tags.replaceAll(' ', '').split(','))
            .then(response => {
                setIsLoading(response.result);
                setIsSuccess(response.result);
                setError(response.error);
            }).catch(error => {
                setIsLoading(false);
                setIsSuccess(false);
                setError(error.message);
            })
    }

    if (isSuccess) {
        return (<Redirect to="/water" />)
    } else {
        return (
            <Fragment>
                <h1>Create a new Water Event</h1>
                <Paper className="paper">
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12} lg={12}>
                            <TextField
                                key="device"
                                id="device"
                                label="DeviceId"
                                value={deviceId}
                                onChange={(e) => setDeviceId(e.target.value)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                margin="normal"
                                variant="outlined"
                                className="input"
                                disabled={isLoading}
                            />
                            <Tooltip title="The Device's 24 digit Device ID">
                                <Icon>info</Icon>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <TextField
                                key="tags"
                                id="tags"
                                label="Tags"
                                value={tags}
                                onChange={(e) => setTags(e.target.value)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                margin="normal"
                                variant="outlined"
                                className="input"
                                disabled={isLoading}
                            />
                            <Tooltip title="The Device's 24 digit Device ID">
                                <Icon>info</Icon>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <TextField
                                key="reviewers"
                                id="reviewers"
                                label="Reviewers"
                                value={reviewers}
                                onChange={(e) => setReviewers(e.target.value)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                margin="normal"
                                variant="outlined"
                                className="input"
                                disabled={isLoading}
                            />
                            <Tooltip title="Reviewers">
                                <Icon>info</Icon>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <TextField
                                key="customTraining"
                                id="customTraining"
                                label="Custom training duration"
                                value={trainingTime}
                                type="number"
                                onChange={(e) => setTrainingTime(e.target.value)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                margin="normal"
                                variant="outlined"
                                className="input"
                                disabled={isLoading}
                            />
                            <Tooltip title="Training time">
                                <Icon>info</Icon>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12} md={12} lg={3}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    format="MM/dd/yyyy"
                                    margin="normal"
                                    id="date-picker-inline"
                                    label="Start Date"
                                    value={regionOfInterestStartDate}
                                    onChange={setRegionOfInterestStartDate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                            <Tooltip title="This is the approximate start date of the event, we will take additional training time before">
                                <Icon>info</Icon>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12} md={12} lg={3}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    format="MM/dd/yyyy"
                                    margin="normal"
                                    id="date-picker-inline"
                                    label="End Date"
                                    value={endDate}
                                    onChange={setEndDate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                            <Tooltip title="This is the approximate end date of the event, or today's date if the event has not yet ended">
                                <Icon>info</Icon>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Grid container>
                                <Grid item>
                                    <div className="buttonWrapper">
                                        <Button
                                            onClick={handleComplete}
                                            color="primary"
                                            variant="contained"
                                            disabled={isLoading}
                                            className={isSuccess ? "buttonSuccess" : ""}
                                        >
                                            Create
                                        </Button>
                                        {isLoading && <CircularProgress size={24} className="buttonProgress" />}
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <div>{error}</div>
                        </Grid>
                    </Grid>
                </Paper>
            </Fragment>
        )
    }
}